import 'dayjs/locale/cs'
import 'dayjs/locale/it'
import 'dayjs/locale/ro'
import 'dayjs/locale/pl'
import 'dayjs/locale/sk'
import 'dayjs/locale/el'
import 'dayjs/locale/hu'
import 'dayjs/locale/uk'
import 'dayjs/locale/fi'
import 'dayjs/locale/sl'
import 'dayjs/locale/et'
import 'dayjs/locale/lt'

import dayjs from 'dayjs'

import { LOCALE } from '../constants/locale.constants'
import { customTranslationHook } from './i18n.hook'

dayjs().locale(LOCALE || 'cs') // set dayjs translation

export const getTranslate = customTranslationHook

export const getCountryCodeFromLanguage = (languageCode: string): string => {
  const languageToCountry = {
    af: 'ZA',
    am: 'ET',
    ar: 'SA',
    az: 'AZ',
    be: 'BY',
    bg: 'BG',
    bn: 'BD',
    bs: 'BA',
    ca: 'ES',
    cs: 'CZ',
    cy: 'GB',
    da: 'DK',
    de: 'DE',
    el: 'GR',
    en: 'GB',
    es: 'ES',
    et: 'EE',
    fa: 'IR',
    fi: 'FI',
    fr: 'FR',
    ga: 'IE',
    gl: 'ES',
    gu: 'IN',
    he: 'IL',
    hi: 'IN',
    hr: 'HR',
    hu: 'HU',
    hy: 'AM',
    id: 'ID',
    is: 'IS',
    it: 'IT',
    ja: 'JP',
    jv: 'ID',
    ka: 'GE',
    kk: 'KZ',
    km: 'KH',
    kn: 'IN',
    ko: 'KR',
    ky: 'KG',
    lo: 'LA',
    lt: 'LT',
    lv: 'LV',
    mk: 'MK',
    ml: 'IN',
    mn: 'MN',
    mr: 'IN',
    ms: 'MY',
    mt: 'MT',
    nb: 'NO',
    ne: 'NP',
    nl: 'NL',
    nn: 'NO',
    pa: 'IN',
    pl: 'PL',
    ps: 'AF',
    pt: 'BR',
    ro: 'RO',
    ru: 'RU',
    si: 'LK',
    sk: 'SK',
    sl: 'SI',
    sq: 'AL',
    sr: 'RS',
    sv: 'SE',
    sw: 'KE',
    ta: 'IN',
    te: 'IN',
    th: 'TH',
    tl: 'PH',
    tr: 'TR',
    uk: 'UA',
    ur: 'PK',
    uz: 'UZ',
    vi: 'VN',
    zh: 'CN',
    zu: 'ZA',
  }

  return languageToCountry[languageCode] || ''
}

export const getLocalisedLanguageName = (languageCode: string) =>
  new Intl.DisplayNames(LOCALE, { type: 'language' }).of(languageCode)
